import { FormGroup, Input, Label } from "@xola/ui-kit";
import React, { ChangeEvent } from "react";
import { ApplyCode } from "types";

interface AffiliateVoucherFormProps {
    voucher: string;
    selectedCode: ApplyCode;
    onChangeVoucher: (value: string) => void;
}

export const AffiliateVoucherForm = ({ voucher, selectedCode, onChangeVoucher }: AffiliateVoucherFormProps) => {
    if (!selectedCode?.affiliateNotification) {
        return null;
    }

    return selectedCode?.voucher ? (
        <FormGroup>
            <Label>Voucher ID</Label>
            <Input
                value={voucher}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChangeVoucher(event.target.value);
                }}
            />
        </FormGroup>
    ) : null;
};
